import reducer from './layout';
import { actionCreators, LayoutActionType } from './layout.actionCreators';
import * as actionTypes from './layout.actionTypes';

export * from './layout';
export * from './layout.selectors';
export type ActionType = LayoutActionType;
export { actionTypes, actionCreators };
export default reducer;
